import {
  BottomSheet,
  BottomSheetIllustrationContent,
  Text,
  type UseModalState,
} from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import { useCallback } from "react";

interface ShiftEndsSoonBottomSheetProps {
  modalState: UseModalState;
  onExtendShift: () => void;
}

export function ShiftEndsSoonBottomSheet(props: ShiftEndsSoonBottomSheetProps) {
  const { modalState, onExtendShift } = props;

  const handleExtendShift = useCallback(() => {
    onExtendShift();
    modalState.closeModal();
  }, [modalState, onExtendShift]);

  const handleClose = useCallback(() => {
    modalState.closeModal();
  }, [modalState]);

  // This will be finished in the subsequent PRs

  return (
    <BottomSheet
      footer={
        <DialogFooter orientation="vertical" onClose={handleClose}>
          <Button fullWidth size="large" onClick={handleExtendShift}>
            Extend shift
          </Button>
        </DialogFooter>
      }
      modalState={modalState}
    >
      <BottomSheetIllustrationContent
        hasFooter
        title="Your shift ends soon"
        description={
          <Stack gap={6}>
            <Text semibold variant="body1" color={(theme) => theme.palette.text.secondary}>
              If you need to stay longer, you can extend your shift to avoid being auto clocked out.
            </Text>
          </Stack>
        }
        illustrationType="hours-limit"
      />
    </BottomSheet>
  );
}
